import * as tslib_1 from "tslib";
import { BaseComponent } from '../base.component';
var PetlBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlBaseComponent, _super);
    function PetlBaseComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        return _this;
    }
    Object.defineProperty(PetlBaseComponent.prototype, "currentProject", {
        get: function () {
            return this.petlService.project;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlBaseComponent.prototype, "currentView", {
        get: function () {
            return this.petlService.currentView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlBaseComponent.prototype, "loading", {
        get: function () {
            return this.petlService.loading;
        },
        set: function (value) {
            this.petlService.loading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlBaseComponent.prototype, "user", {
        get: function () {
            return this.petlService.user;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlBaseComponent.prototype, "service", {
        get: function () {
            return this.petlService;
        },
        enumerable: true,
        configurable: true
    });
    PetlBaseComponent.prototype.detectChanges = function () {
        this.cdr.detectChanges();
    };
    PetlBaseComponent.prototype.changeView = function (viewName) {
        this.petlService.changeView(viewName);
    };
    PetlBaseComponent.prototype.toggleHelp = function () {
        this.showHelp = !this.showHelp;
    };
    PetlBaseComponent.prototype.toggleView = function (viewName) {
        this.petlService.toggleView(viewName);
    };
    return PetlBaseComponent;
}(BaseComponent));
export { PetlBaseComponent };
